import React from 'react';

import Overlay from '../../_blocks/Overlay';
import SquareBody from '../../_blocks/SquareBody';

import closeButtonIcon from '../../../../public/images/icons/white-modal-close-icon.svg';

import styles from './SquareModal.module.scss';

const {
  'mobile-scroll-container': mobileScrollContainerClass,
  'close-button': closeButtonClass,
  'modal-footer': modalFooterClass
} = styles;

const SquareModal = ({
  children,
  closeModal,
  closeOnOverlayClick = false,
  customOverlayClass,
  customBodyClass,
  hideCloseButton,
  modalVisible,
  renderFooterContent = null
}) => {
  return (
    <Overlay
      {...{ closeModal, modalVisible }}
      customClass={customOverlayClass}
      closeOnClick={closeOnOverlayClick}
    >
      <div className={mobileScrollContainerClass}>
        {!hideCloseButton && (
          <img src={closeButtonIcon} className={closeButtonClass} onClick={closeModal} />
        )}
        <SquareBody {...{ closeModal }} customClass={customBodyClass}>
          {children}
          {!!renderFooterContent && <div className={modalFooterClass}>{renderFooterContent()}</div>}
        </SquareBody>
      </div>
    </Overlay>
  );
};

export default SquareModal;
